import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  Users,
  Tag,
  Server,
  LogOut,
  LayoutDashboard,
  Monitor,
  CreditCard,
  Menu,
  X,
  Download,
  Bell,
  Megaphone,
  HelpCircle,
  FileText,
  Activity,
} from "lucide-react";
import styles from "./AdminLayout.module.css";

const AdminLayout: React.FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Close sidebar whenever the route changes
  useEffect(() => {
    setIsSidebarOpen(false);
  }, [location.pathname]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className={styles.container}>
      {/* Mobile Overlay */}
      {isSidebarOpen && (
        <div className={styles.overlay} onClick={closeSidebar}></div>
      )}

      <aside
        className={`${styles.sidebar} ${isSidebarOpen ? styles.open : ""}`}
      >
        <div className={styles.logo}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <img
              src="/logo.png"
              alt="One Support Admin"
              style={{ height: "32px", display: "block" }}
            />
            <button className={styles.closeBtn} onClick={closeSidebar}>
              <X size={24} />
            </button>
          </div>
        </div>
        <nav className={styles.nav}>
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ""}`
            }
          >
            <LayoutDashboard className={styles.icon} size={20} />
            대시보드
          </NavLink>
          <NavLink
            to="/notices"
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ""}`
            }
          >
            <Bell className={styles.icon} size={20} />
            공지 관리
          </NavLink>
          <NavLink
            to="/banner"
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ""}`
            }
          >
            <Megaphone className={styles.icon} size={20} />
            상단 배너 관리
          </NavLink>
          <NavLink
            to="/faqs"
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ""}`
            }
          >
            <div className={styles.icon}>
              <HelpCircle size={20} />
            </div>
            FAQ 관리
          </NavLink>
          <NavLink
            to="/file-logs"
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ""}`
            }
          >
            <div className={styles.icon}>
              <FileText size={20} />
            </div>
            파일 전송 로그
          </NavLink>
          <NavLink
            to="/relay-logs"
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ""}`
            }
          >
            <Activity className={styles.icon} size={20} />
            Relay 트래픽
          </NavLink>
          <NavLink
            to="/users"
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ""}`
            }
          >
            <Users className={styles.icon} size={20} />
            회원 관리
          </NavLink>
          <NavLink
            to="/devices"
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ""}`
            }
          >
            <Monitor className={styles.icon} size={20} />
            기기 관리
          </NavLink>
          <NavLink
            to="/plans"
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ""}`
            }
          >
            <Tag className={styles.icon} size={20} />
            요금제 관리
          </NavLink>
          <NavLink
            to="/payments"
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ""}`
            }
          >
            <CreditCard className={styles.icon} size={20} />
            결제 내역
          </NavLink>
          <NavLink
            to="/apps"
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ""}`
            }
          >
            <Download className={styles.icon} size={20} />
            프로그램 관리
          </NavLink>
          <NavLink
            to="/promotions"
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ""}`
            }
          >
            <Tag className={styles.icon} size={20} />
            프로모션
          </NavLink>
          <NavLink
            to="/servers"
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ""}`
            }
          >
            <Server className={styles.icon} size={20} />
            서버 관리
          </NavLink>
          <NavLink
            to="/versions"
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ""}`
            }
          >
            <Tag className={styles.icon} size={20} />
            버전 관리
          </NavLink>
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ""}`
            }
          >
            <Users className={styles.icon} size={20} />
            제휴 문의
          </NavLink>
        </nav>
        <div className={styles.footer}>
          <button onClick={handleLogout} className={styles.logoutButton}>
            <LogOut size={20} />
            로그아웃
          </button>
        </div>
      </aside>
      <main className={styles.main}>
        <header className={styles.header}>
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <button className={styles.menuBtn} onClick={toggleSidebar}>
              <Menu size={24} />
            </button>
            <h3>관리자 대시보드</h3>
          </div>
          <div className={styles.userMenu}>관리자</div>
        </header>
        <div className={styles.content}>
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
